module.exports = __webpack_public_path__ + "img/knowledge.36c91007.png";